export default {
  // メニュー項目
  menu: {
    dashboard: {
      en: 'Dashboard',
      ja: 'ダッシュボード',
    },
    programs: {
      en: 'Programs',
      ja: '番組表',
    },
    players: {
      en: 'Players',
      ja: 'プレイヤー',
    },
    monitoring: {
      en: 'Monitoring',
      ja: 'モニタリング',
    },
    logs: {
      en: 'Logs',
      ja: 'ログ',
    },
    profile: {
      en: 'Profile',
      ja: 'プロフィール',
    },
    logout: {
      en: 'Logout',
      ja: 'ログアウト',
    },
  },

  // 共通ボタン
  buttons: {
    create: {
      en: 'Create',
      ja: '作成',
    },
    edit: {
      en: 'Edit',
      ja: '編集',
    },
    delete: {
      en: 'Delete',
      ja: '削除',
    },
    cancel: {
      en: 'Cancel',
      ja: 'キャンセル',
    },
    save: {
      en: 'Save',
      ja: '保存',
    },
    close: {
      en: 'Close',
      ja: '閉じる',
    },
    confirm: {
      en: 'Confirm',
      ja: '確認',
    },
    update: {
      en: 'Update',
      ja: '更新',
    },
    back: {
      en: 'Back',
      ja: '戻る',
    },
    search: {
      en: 'Search',
      ja: '検索',
    },
    reset: {
      en: 'Reset',
      ja: 'リセット',
    },
  },

  // 共通メッセージ
  messages: {
    loading: {
      en: 'Loading...',
      ja: '読み込み中...',
    },
    noData: {
      en: 'No data found',
      ja: 'データが見つかりません',
    },
    confirmDelete: {
      en: 'Are you sure you want to delete this? This action cannot be undone.',
      ja: 'この項目を削除してもよろしいですか？この操作は元に戻せません。',
    },
    deleteSuccess: {
      en: 'Successfully deleted.',
      ja: '正常に削除されました。',
    },
    error: {
      en: 'An error occurred.',
      ja: 'エラーが発生しました。',
    },
  },

  // 共通フォームラベル
  form: {
    required: {
      en: 'Required',
      ja: '必須',
    },
  },

  // ページネーション
  pagination: {
    rowsPerPage: {
      en: 'Rows per page:',
      ja: '1ページあたりの行数:',
    },
    displayedRows: {
      en: '{{from}}-{{to}} of {{count}}',
      ja: '{{from}}-{{to}} / {{count}}',
    },
  },

  // ステータス
  status: {
    initial: {
      en: 'Initial state',
      ja: '初期状態',
    },
    fetched: {
      en: 'Fetched',
      ja: '準備中',
    },
    ready: {
      en: 'Ready',
      ja: '再生準備完了',
    },
    playing: {
      en: 'Playing',
      ja: '再生中',
    },
    ended: {
      en: 'Ended',
      ja: '再生終了',
    },
    completed: {
      en: 'Completed',
      ja: '完了',
    },
    unknown: {
      en: 'Unknown ({{status}})',
      ja: '不明({{status}})',
    },
  },

  // プレイリスト
  playlist: {
    status: {
      active: {
        en: 'Active',
        ja: 'アクティブ',
      },
      draft: {
        en: 'Draft',
        ja: '下書き',
      },
      archived: {
        en: 'Archived',
        ja: 'アーカイブ',
      },
    },
  },

  // 404ページ
  notFound: {
    title: {
      en: 'Page Not Found',
      ja: 'ページが見つかりません',
    },
    message: {
      en: 'The page you are looking for does not exist or may have been moved.',
      ja: 'お探しのページは存在しないか、移動された可能性があります。',
    },
    backToHome: {
      en: 'Back to Home',
      ja: 'ホームに戻る',
    },
  },

  // エラーメッセージ
  errors: {
    network: {
      en: 'Cannot connect to server. Please check your internet connection.',
      ja: 'サーバーに接続できません。インターネット接続を確認してください。',
    },
    authentication: {
      en: 'Authentication failed. Please log in again.',
      ja: '認証に失敗しました。再ログインしてください。',
    },
    authorization: {
      en: 'You do not have permission to perform this action.',
      ja: 'この操作を行う権限がありません。',
    },
    resourceNotFound: {
      en: 'The requested resource was not found.',
      ja: '要求されたリソースが見つかりませんでした。',
    },
    validation: {
      en: 'Invalid input data. Please check your entries.',
      ja: '入力データが無効です。入力内容を確認してください。',
    },
    database: {
      en: 'Database operation failed. Please try again later.',
      ja: 'データベース操作に失敗しました。しばらく経ってからもう一度お試しください。',
    },
    dateProcessing: {
      en: 'An error occurred while processing the date. Please check the date format.',
      ja: '日付の処理中にエラーが発生しました。日付形式を確認してください。',
    },
    generic: {
      en: 'An error occurred. Please try again later.',
      ja: 'エラーが発生しました。しばらく経ってからもう一度お試しください。',
    },
    unexpected: {
      en: 'An unexpected error occurred.',
      ja: '予期しないエラーが発生しました。',
    },
    loginFailed: {
      en: 'Login failed. Please check your credentials and try again.',
      ja: 'ログインに失敗しました。認証情報を確認して再度お試しください。',
    },
    logRetrievalFailed: {
      en: 'Failed to retrieve logs. Please try again later.',
      ja: 'ログの取得に失敗しました。しばらく経ってからもう一度お試しください。',
    },
  },

  // 検索
  search: {
    placeholder: {
      en: 'Search...',
      ja: '検索...',
    },
  },
};
